__turbopack_context__.v({
  "root": "checkbox-list-module-scss-module__j1uJ8W__root",
});
